<template>
  <div>
    <div v-if="!commissions.length" class="label">Commission(s)</div>
    <div v-for="(commission, i) in commissions" :key="commission.commission_id">
      <CommissionField
        :ref="
          (el) => {
            if (el) commissionFieldRefs[commission.id] = el;
          }
        "
        :commission="commission"
        :technicians="technicians"
        :index="i"
        v-bind="$attrs"
      />
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import CommissionField from "./CommissionField.vue";
export default {
  components: {
    CommissionField
  },
  props: {
    commissions: {
      type: Array,
      default: () => []
    },
    technicians: {
      type: Array,
      default: () => []
    }
  },
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      commissionFieldRefs: {}
    };
  },
  methods: {
    async validateAllFields() {
      let allValid = true;

      for (const commission of this.commissions) {
        const fieldRef = this.commissionFieldRefs[commission.id];
        if (fieldRef?.v$?.$validate) {
          const isValid = await fieldRef.v$.$validate();
          if (!isValid) {
            allValid = false;
          }
        }
      }

      return allValid;
    }
  }
};
</script>

<style lang="scss" scoped></style>
